module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block width_full"
  }, [_c('button', {
    class: {
      "width_full": true, "primary-green-bg": !_vm.error, "red-bg": _vm.error
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.buttonAction
    }
  }, [_vm._v("\n   " + _vm._s(_vm.buttonText || 'PROCEED') + "\n ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f30393a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/button-panel/SingleButton.vue
// module id = 384
// module chunks = 2